(function (app, ng) {
    app.component("agentOfficeSupport", {
        templateUrl: "/App/Dashboard/ConfigureAgentAccount/OfficeSupport/template.html",
        controller: agentOfficeSupportController,
        bindings: {
            onSave: "&",
            user: "<",
            agent: "<",
            viewAsUserRoles: "<"
        }
    });

    agentOfficeSupportController.$inject = ["$q", "transactionGroupApi", "_", "userDelegateApi", "userApi", "$scope"];

    function agentOfficeSupportController($q, transactionGroupApi, _, userDelegateApi, userApi, $scope) {
        var $ctrl = this;

        this.$onInit = function () {
            $ctrl.onSave({
                $func: function () {
                    return updateUserDelegates();
                }
            });

            populateUserDelegates();
        };

        function populateUserDelegates() {
            //console.log($ctrl.user.TransactionGroupId)
            var getTransactionGroupAgents = transactionGroupApi.getTransactionGroupAgents($ctrl.user.TransactionGroupId).catch(ng.noop);
            var getUsersForDelegateUser = userApi.getUsersForDelegateUser($ctrl.user.UserId).catch(ng.noop);
            var getTransactionGroupPossibleDelegates = transactionGroupApi.getTransactionGroupPossibleDelegates($ctrl.user.TransactionGroupId).catch(ng.noop);
            var getDelegatesForUser = userApi.getAllDelegatesForUser($ctrl.user.UserId).catch(ng.noop);
            $ctrl.parentUsersUpdated = false;
            $q.all([getTransactionGroupAgents, getUsersForDelegateUser, getTransactionGroupPossibleDelegates, getDelegatesForUser]).then(
                function (data) {
                    $ctrl.groupAgents = data[0];
                    $ctrl.onBehalfOfAgents = data[1];
                    $ctrl.allDelegateUsers = data[2];
                    $ctrl.delegateUsers = data[3];

                    //remove selected user from lists
                    ng.forEach($ctrl.groupAgents,
                        function (ga, index) {
                            if (ga.UserId === $ctrl.user.UserId) {
                                $ctrl.groupAgents.splice(index, 1);
                            }
                        });

                    ng.forEach($ctrl.allDelegateUsers,
                        function (adu, index) {
                            if (adu.UserId === $ctrl.user.UserId) {
                                $ctrl.allDelegateUsers.splice(index, 1);
                            }
                        });

                    //Add additional properties to arrays of users to process delegate api calls
                    ng.forEach($ctrl.groupAgents, function (ga) {

                        ng.forEach($ctrl.onBehalfOfAgents, function (oba) {
                            if (ga.UserId === oba.OnBehalfOfUserId) {
                                ga.AddAsOfficeSupport = true;
                                ga.UserDelegateId = oba.Id;
                            }
                        });
                    });

                    ng.forEach($ctrl.allDelegateUsers, function (adu) {
                        adu.DisableAddAsOfficeSupport = true;

                        ng.forEach($ctrl.delegateUsers, function (du) {
                            if (adu.UserId === du.UserId) {
                                adu.AddAsOfficeSupport = true;
                                adu.UserDelegateId = du.Id;
                            }
                        });
                    });
                });
        }

        function updateUserDelegates() {
            var promises = [];
            var addUserAsDelegate = [];
            var removeUserAsDelegate = [];
            ng.forEach($ctrl.allDelegateUsers, function (delegate) {
                if (delegate.AddAsOfficeSupport)
                    addUserAsDelegate.push(delegate);
            });

            ng.forEach($ctrl.allDelegateUsers, function (delegate) {
                if (delegate.AddAsOfficeSupport !== null && delegate.AddAsOfficeSupport === false)
                    removeUserAsDelegate.push(delegate);
            });

            ng.forEach(addUserAsDelegate, function (delegate) {
                var delegateModel = {
                    UserId: delegate.UserId,
                    OnBehalfOfUserId: $ctrl.user.UserId,
                    //Roles: onBehalfOfAgent.Roles
                    Roles: ["Agent"] //modify this based on what we would like to set or if there are restrictions.
                }
                promises.push(userDelegateApi.createUserDelegate(delegateModel));
            });

            ng.forEach(removeUserAsDelegate, function (delegate) {
                promises.push(userDelegateApi.removeUserDelegate(delegate.UserDelegateId));
            });

            var addUserToOnBehalfOfAgents = [];
            var removeUserFromOnBehalfOfAgents = [];
            ng.forEach($ctrl.groupAgents, function (agent) {
                console.log(agent)
                if (agent.AddAsOfficeSupport)
                    addUserToOnBehalfOfAgents.push(agent);
            });

            ng.forEach($ctrl.groupAgents, function (agent) {
                if (agent.AddAsOfficeSupport !== null && agent.AddAsOfficeSupport === false)
                    removeUserFromOnBehalfOfAgents.push(agent);
            });

            ng.forEach(addUserToOnBehalfOfAgents, function (onBehalfOfAgent) {
                var delegateModel = {
                    UserId: $ctrl.user.UserId,
                    OnBehalfOfUserId: onBehalfOfAgent.UserId,
                    //Roles: onBehalfOfAgent.Roles
                    Roles: ["Agent"] //modify this based on what we would like to set or if there are restrictions.
                }

                promises.push(userDelegateApi.createUserDelegate(delegateModel));
            });

            ng.forEach(removeUserFromOnBehalfOfAgents, function (onBehalfOfAgent) {
                promises.push(userDelegateApi.removeUserDelegate(onBehalfOfAgent.UserDelegateId));
            });

            //update parent variable to note whether to refresh dashboard if parent Users are updated (select parent user box at top will change)
            $scope.$parent.$parent.$ctrl.parentUsersUpdated = $ctrl.parentUsersUpdated;

            return $q.all(promises).then(function () {
                console.log("Updated User - Delegate References");
                populateUserDelegates();
                return;
            });
        }
    }
})(window.app, window.angular); // jshint ignore:line